import React, { useContext } from 'react'
import { PortalComponent } from '../modals/portal'
import { Modal, ModalSize } from '../modals/modal'
import { useSearchViewState } from '../../contexts/search-view-state-context'
import { UserLocationContext } from '../../contexts/user-location-context'
import { NewFormActionArea } from '../form-action-area/form-action-area'
import { useATTrackInteraction } from '@at/consumer-web-snowplow'
import { useFormState } from '../../forms/hocs/form.state'
import { useChannel } from '../../hooks/use-abtest.hook'

export const PortalAndModal = ({
    children,
    showChildren,
    forceOpenModal,
}: {
    children: React.ReactElement
    showChildren: boolean
    forceOpenModal?: boolean
}) => {
    const { showSearchFilter, toggleSearchFilter } = useSearchViewState()
    const channel = useChannel()
    const { error: postcodeError } = useContext(UserLocationContext)

    if (forceOpenModal) toggleSearchFilter(true)
    const trackCloseSearchModal = useATTrackInteraction({
        trackingLabel: 'search-filter-modal-close',
    })
    const { collapseFilterGroups } = useFormState()

    return (
        <PortalComponent show={showChildren}>
            <Modal
                closeModalFn={() => {
                    trackCloseSearchModal()
                    toggleSearchFilter(false)
                    collapseFilterGroups()
                }}
                modalSize={ModalSize.FULL_SCREEN}
                footerChildren={
                    <NewFormActionArea
                        channel={channel}
                        toggleSearchFilter={toggleSearchFilter}
                        hasPostcodeError={postcodeError}
                    />
                }
                isModalShowing={showSearchFilter}
            >
                {children}
            </Modal>
        </PortalComponent>
    )
}
